import { render, staticRenderFns } from "./TemporaryMediaUploadList.vue?vue&type=template&id=01c2db94"
import script from "./TemporaryMediaUploadList.vue?vue&type=script&lang=js"
export * from "./TemporaryMediaUploadList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports